<template>
    <div>
        <label class="block text-white font-bold text-sm md:text-base">{{ label }}</label>
        <div class="w-full h-10 relative">
        <select v-model="itemValue"
                class="w-full h-full bg-white px-5 rounded-lg appearance-none focus:outline-none"
                ref="input"
                v-bind="$attrs">
            <option value="">Select</option>
            <option v-for="option in modifiedOptions"
                    :key="option.id"
                    :value="option.id">
                {{ option.name }}
            </option>
        </select>
        <div class="absolute inset-y-0 flex items-center right-0">
                                    <svg class="w-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 10L12 15L17 10" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
        </div>
        <div v-if="error"
             class="text-red-500 text-sm mt-2"
             v-text="error"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        options: {
            type: Array,
            default: () => [],
        },
        label: {},
        error: {},
    },

    data() {
        return {
            itemValue: ""
        }
    },

    computed: {
        modifiedOptions() {
            if (this.options.length > 0 && this.options[0].id === undefined) {
                return this.options.map((a) => ({id: a, name: a}));
            }

            return this.options;
        },
    },

    methods: {},

    watch: {
        itemValue(itemValue) {
            this.$emit('input', itemValue);
        },

        value: {
            immediate: true,
            handler(value) {
                this.itemValue = value;
            }
        }
    },

    mounted() { }
};
</script>